import { createI18n } from 'vue-i18n'
import { messages } from './messages'

const i18n = createI18n({
  legacy: false,
  locale: 'zh',
  fallbackLocale: 'zh',
  globalInjection: true,
  messages,
  missingWarn: false,
  fallbackWarn: false
})

export function setI18nLocale (locale) {
  i18n.global.locale.value = locale === 'ja' ? 'ja' : 'zh'
}

export default i18n
